












import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import { TaskContent } from "../../Classes/Entities/Chat/TaskContent";
import { ThreadRepository } from "../../Classes/Infrastractures/ThreadRepository";
import firebase, { firestore } from 'firebase';
import { DummyPlainObject } from "../../Classes/Entities";


@Component
export default class TaskThreadOverview extends Vue {
  @Prop() 
  public taskContent!:TaskContent;
  @Prop() 
  public functionId!: string;

  public _title!: string;

  public _contents!: string;

  public get title() {
    return this._title;
  }

  public set title(title:string) {
    this._title = title;
  }

  public get contents() {
    return this._contents;
  }
  public set contents(contents:string) {
    this._contents = contents;
  }

  public onClick() {
    if (! this._contents || ! this._title) return;

    //TODO auth情報から取得するように変更
    const names:DummyPlainObject = {
      '3E9f2uVgwOa3g6FdmGsHgh7bGO02': '鈴木 涼介',
      '9EQnLueKkwRIk9weB6CZrslSOKO2': '田中 康夫',
      'MBUNtGUKY7fbPQQfxWq1Z92fvd73': '佐藤 史顕',
      'AxK2Bnt3S2WvkPUhTLFBmnav2bV2': '高橋 綾子',
      'jQJU7s4yvLNusL5Set9v0JSjDsi2': '山崎 恵美',
      'svc26irAkTO6SJvvEu7x1tj1OoH2': '長谷川 慎太郎',
      'z19i6aucp1awbNNYLDkbJU50d6S2': '渡辺 雄太',
    }

    const threadRepository = ThreadRepository.getInstanceById(this.taskContent.id);
    const uid: string = firebase.auth().currentUser!.uid;
    const name:string = names[uid];
    
    if (threadRepository != null)
    threadRepository.save({
      contents: this._contents,
      title: this._title,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      user_id: uid,
      username: name
    })


    const isInputable = (data:any): data is HTMLTextAreaElement|HTMLInputElement => {
      return data.value != undefined;
    }

    const contentsForm:Vue | Element | Vue[] | Element[] = this.$refs.textarea;
    if (isInputable(contentsForm)) {
        contentsForm.value = '';
        this._contents = '';
    }

    const titleForm:Vue | Element | Vue[] | Element[] = this.$refs.input;
    if (isInputable(titleForm)) {
        titleForm.value = '';
        this._title = '';
    }
  }
}
